import { useSyncExternalStore } from 'react';
const STORAGE_KEY = 'dnd-editor-view-mode';
function load() {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        if (v === 'creator' || v === 'admin')
            return v;
    }
    catch (_a) {
        /* ignore */
    }
    return 'admin'; // admins land in the admin view; the top-bar toggle switches to creator
}
let current = load();
const listeners = new Set();
export function getViewMode() {
    return current;
}
export function setViewMode(next) {
    current = next;
    try {
        localStorage.setItem(STORAGE_KEY, next);
    }
    catch (_a) {
        /* ignore */
    }
    listeners.forEach(l => l());
}
function subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
export function useViewMode() {
    return useSyncExternalStore(subscribe, getViewMode, getViewMode);
}
